import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e818cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
    default: "",
  },
  subtitle: {
    type: String,
    default: null,
  },
  action: {
    type: Function,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  stroke: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
  send: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["base-button", {
      stroke: __props.stroke,
      disabled: __props.disabled,
      small: __props.small,
      send: __props.send,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.action()))
  }, [
    _createTextVNode(_toDisplayString(__props.title) + " ", 1),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})